import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import AcademiaButton from '../../CommonComps/Buttons/AcademiaButton';
import AddFeatureModal from '../../CommonComps/Modals/AddFeatureModal';

const AddFeatureAction = ({
  hasCreatePermission,
}: {
  hasCreatePermission: boolean;
}) => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);

  // rendering create feature action component here
  return (
    <div>
      <AcademiaButton
        title={
          !hasCreatePermission ? 'You do not have permissions!' : undefined
        }
        type='button'
        onClick={() => setShowModal(true)}
        variant='info'
        icon={<TbSquareRoundedPlusFilled className='size-6' />}
        isDisabled={!hasCreatePermission}
      >
        Add Feature
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <AddFeatureModal handleModalClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </div>
  );
};

export default AddFeatureAction;
